/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
import { SvgIconTypeMap } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import ErrorIcon from '@material-ui/icons/Error'
import { payouts } from 'Modules/Analytics/trackActionInterface/Fundraising/payouts'

export const notificationData: NotificationDataType = {
  PAYOUT_FAILED: {
    icon: ErrorIcon,
    message:
      'Your donations payout failed. Please try updating your banking information to receive payouts.',
    redirect: '/settings/fundraising',
    isDismissible: true,
    events: {
      clicked: payouts.Failed_Payout_Banner_Clicked,
      dismissed: payouts.Failed_Payout_Banner_Dismissed,
    },
  },
}

type NotificationDataType = Record<
  NOTIFICATION_TYPES,
  {
    icon: OverridableComponent<SvgIconTypeMap>
    message: string
    redirect: string
    isDismissible: boolean
    events: NotificationEventType
  }
>

type NotificationEventType = {
  clicked: Record<string, unknown>
  dismissed: Record<string, unknown>
}

export enum NOTIFICATION_TYPES {
  PAYOUT_FAILED = 'PAYOUT_FAILED',
}

export type NotificationType = {
  type: NOTIFICATION_TYPES
  status: string
  dateCreated: Date
}
